<!-- eslint-disable vue/no-mutating-props -->
<template>
  <BaseCard class="card" :checked="checked" :data-source="dataSource">
    <template #cover>
      <div class="card-cover">
        <div
          v-if="dataSource.resource_type === RESOURCE_TYPE.FONT"
          class="cover-img w-full h-full flex-center p-[4px]"
        >
          <Resource
            :src="dataSource.cover"
            class="!w-auto max-w-full !h-[24px]"
          />
        </div>

        <Resource
          v-else-if="showImage"
          class="cover-img"
          :src="dataSource.cover"
          :alt="dataSource.name"
          :class="{ horizontal: !dataSource?.vertical }"
        />

        <slot name="cover"></slot>
        <!--过期提醒，回收站专用-->
        <ExpiredCard
          v-if="dataSource?.expired"
          class="absolute bottom-0 left-0 z-20"
          :expired="dataSource.expired"
        />
      </div>
    </template>
    <template v-if="$slots.menu" #menu>
      <slot name="menu"></slot>
    </template>
    <slot></slot>
    <div v-if="$slots.body" class="card-body">
      <slot name="body"></slot>
    </div>
  </BaseCard>
</template>
<script lang="ts" setup>
import BaseCard from '../base/index.vue'
import ExpiredCard from '../expired/index.vue'

const props = withDefaults(
  defineProps<{
    dataSource?: any
    checked?: boolean
  }>(),
  {
    dataSource: () => ({}),
    checked: false,
  }
)

// const currentTheme = useTheme()
// const isDark = computed(() => currentTheme?.value === 'dark')
// const mediaData = useMedia({ src: props.dataSource?.cover, type: 'img' })

const showImage = computed(() => {
  if (props.dataSource?.isDelete && !props.dataSource?.cover) {
    return false
  }

  return props.dataSource?.showImage ?? true
})
</script>
<style lang="scss" scoped>
.card {
  @apply w-full h-auto relative flex flex-col;
  .card-cover {
    @apply relative h-auto w-full overflow-hidden rounded-tr-[10px] rounded-tl-[10px] bg-back-4;

    img {
      @apply block w-full h-full border-none align-middle transition-transform duration-[400ms] object-contain;

      &.horizontal {
        @apply object-contain;
      }
    }
  }

  .card-body {
    @apply p-[12px] w-full flex-1;
  }

  &:hover {
    img {
      @apply scale-105;
    }
  }
}
</style>
